/**
 * SessionNotice — shows why the session ended, when the user did not end it.
 *
 * The session layer (services/sessionRefresh.js) runs outside React, so it
 * cannot raise a toast; it leaves the message in the auth slice and this shows
 * it once, as an error toast — legacy's red "Session expired. Please login
 * again." (apiservice.js:201). Mounted once, inside the ToastProvider. Renders
 * nothing.
 */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useNotify } from '@hooks/useNotify';
import { noticeShown, selectAuthNotice } from '@security/auth/authSlice';

export function SessionNotice() {
  const dispatch = useDispatch();
  const notify = useNotify();
  const notice = useSelector(selectAuthNotice);

  useEffect(() => {
    if (!notice) return;
    notify.error(null, notice);
    dispatch(noticeShown());
  }, [notice, notify, dispatch]);

  return null;
}

export default SessionNotice;
